import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { withLatestFrom, concatMap, delay } from 'rxjs/operators';
import { Action } from 'redux';
import { push } from 'connected-react-router';
import { TakedownReleaseSuccess } from '../action-creators';
import { TAKEDOWN_RELEASE_SUCCESS } from '../actions';
import { GetCatalog } from '@webapp/store/catalog/action-creators';
import AppState from '../../state';

export const redirectAfterTakedownEpic = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, TakedownReleaseSuccess>(TAKEDOWN_RELEASE_SUCCESS),
    withLatestFrom(state$),
    delay(2000),
    concatMap(([_action, state]) => {
      return [
        new GetCatalog(),
        new GetCatalog({
          type: 'COLLABORATOR',
          artistId: state.artist.active?.id,
        }),
        push('/catalog'),
      ];
    })
  );
